import React from 'react';
import { useState, useContext, useCallback } from 'react';

import quizInstanceAdminStatusContext from '../context/quizInstanceAdminStatusContext';
import QuizAdminProgressBar from './QuizAdminProgressBar';

export default function QuizAdminLobbyTimer(props) {

  const ctx = useContext(quizInstanceAdminStatusContext);
	const [label, setLabel] = useState("");
	const updateLabel = useCallback(updateArgs => {
		setLabel(`Tid kvar (${updateArgs.remainingMinutesAndSeconds})`);
	}, []);

	return (
		<div className="quizAdminLobbyTimer">
			<h3>{label}</h3>
			<QuizAdminProgressBar 
				startedAt={ctx.quizInfo.startedAt} 
				endsAt={ctx.quizInfo.endsAt} 
				onUpdated={updateLabel}
				onElapsed={() => ctx.callbacks.setForceQuizEnd(true)}
			/>
		</div>
	);
}